<template>
  <section class="company-info-section">
    <b-container>
      <b-row>
        <b-col sm="12" md="12" lg="12">
          <div class="company-info-container">
            <div class="img-container">
              <img src="@/assets/img/independent-game-studio-logo_agatis.svg" alt="Independent game studio">
            </div>
            <div class="company-text">
              {{$t('company_info_text')}}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";

 .company-info-section{
    padding-top: 80px;
    padding-bottom: 80px;
    background: #20201E;
    .company-info-container {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      gap: 40px;
      max-width: 600px;
      width: 100%;
      margin: 0 auto;
          @media screen and (min-width: 320px) {
            align-items: center;
          }
          @media screen and (min-width: 768px) {
            align-items: flex-end;
          }
      .img-container{
        img{
          @media screen and (min-width: 320px) {
            max-width: 96px;
          }
          @media screen and (min-width: 768px) {
            max-width: unset;
          }
        }
      }
      .company-text{
        color: #FFF;
        font-family: $main-font;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height:  25.2px;
        @media screen and (min-width: 320px) {
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 19.6px;
        }
        @media screen and (min-width: 768px) {
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height:  25.2px;
        }
      }
    }
 }
</style>
